module.exports = __webpack_public_path__ + "static/media/Suspension_kits_Black.0694c393.webp";